<template>
	<div class="wf-poi" v-if="poi">
		<div class="wf-poi-info">
			<div class="wf-poi-image" v-if="showLogo" :style="{'background-image': getImage()}" :class="[isImage()]"></div>
			<div class="wf-poi-name" v-if="showName" v-html="poi.getName(language) || 'POI'"></div>
			<div class="wf-path-buttons">
				<div class="wf-show-path" v-if="showPathButton" @click="showPath">
					<button>
						<label data-translation-element="show_path">{{show_path}}</label> <i></i>
					</button>
				</div>
				<div class="wf-show-path wf-show-accessibility-path" v-if="showAccessibilityPathButton" v-touch:tap="showAccessibilityPath">
					<button>
						<label data-translation-element="show_accessibility_path">{{show_accessibility_path}}</label> <i class="accessibility-i"></i>
					</button>
				</div>
			</div>
		</div>
		<!-- <div class="wf-poi-description" v-if="showDescription" v-html="poi.getDescription(language) || ''"></div> -->
		<div class="wf-poi-description" v-if="showDescription">
			<div v-if="this.poi.email">
				<span class="email-label" data-translation-element="email_label">{{email_label}}: </span>
				<p data-translation-element="email">{{this.poi.email}}</p>

			</div>
			<div v-if="showDescriptionByLanguage().trim() !== ''">
				<span class="description-label" data-translation-element="description_label">{{description_label}}: </span>
				<p data-translation-element="description"  v-html="showDescriptionByLanguage().trim()"></p>
			</div>
			<div v-if="this.poi.phone">
				<span class="phone-label" data-translation-element="phone_label">{{phone_label}}: </span>
				<p data-translation-element="phone">{{this.poi.phone}}</p>
			</div>
			<div v-if="this.poi.web">
				<span class="web-label" data-translation-element="web_label">{{web_label}}: </span>
				<p data-translation-element="web">{{this.poi.web}}</p>
			</div>
			<div v-if="showOpenByLanguage().trim() !== ''">
				<span class="open-label" data-translation-element="open_label">{{open_label}}: </span>
				<p data-translation-element="open" v-html="showOpenByLanguage().trim()"></p>
			</div>
		</div>
		<div class="wf-poi-room_id" v-if="showRoomID" v-html="poi.room_id || ''"></div>
		<div class="wf-poi-floor" v-if="showFloor && poi.getFloor()" v-html="poi.getFloor().getName(language) || ''"></div>
	</div>
</template>

<script>
/* global wayfinder: false */
import { mapState } from 'vuex';

export default {
	name: "POI",
	computed: {
		...mapState('wf', ['language']),
		hasShowPathListener(){
			return !!(this.$listeners && this.$listeners.showPath);
		},
		hasShowAccessibilityPathListener () {
			return !!(this.$listeners && this.$listeners.showPath);
		}
	},
	props: {
		poi: {
			type: Object,
			default: null
		},
		showLogo: {
			type: Boolean,
			default: false
		},
		showName: {
			type: Boolean,
			default: true
		},
		showPathButton: {
			type: Boolean,
			default: false
		},
		showAccessibilityPathButton: {
			type: Boolean,
			default: false
		},
		showDescription: {
			type: Boolean,
			default: false
		},
		showRoomID: {
			type: Boolean,
			default: false
		},
		showFloor: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		language () {
			if (this.$wayfinder) {
				this.show_path = this.$wayfinder.translator.get('show_path');
				this.show_accessibility_path = this.$wayfinder.translator.get('show_accessibility_path');
				this.email_label = this.$wayfinder.translator.get('email_label');
				this.description_label = this.$wayfinder.translator.get('description_label');
				this.phone_label = this.$wayfinder.translator.get('phone_label');
				this.open_label = this.$wayfinder.translator.get('open_label');
				this.web_label = this.$wayfinder.translator.get('web_label');
			}
		}
	},
	methods: {
		showPath () {
			console.log("path data", this.poi);
			this.$emit('showPath', this.poi);
		},
		showAccessibilityPath () {
			this.$emit('showAccessibilityPath', this.poi);
		},
		open (type) {
			if (type && this.poi[type]) {
				if (type === 'shop_email') {
					window.open('mailto:' + this.poi[type], '_system')
				}
				else if (type === 'shop_phone') {
					window.open('tel:' + this.poi[type], '_system')
				}
				else {
					window.open(this.poi[type], '_system')
				}
			}
		},
		getImage () {
			if (this.poi.getBackgroundUrl())
				return 'url("' + this.poi.getBackgroundUrl() + '")';
				
			else if (this.poi.getIconUrl()) {
				return 'url("' + this.poi.getIconUrl() + '")';
			}
			else {
				return "";
			}
		},
		isImage () {
			if(this.poi.getBackgroundUrl()) return "image-background";
			else if (this.poi.getIconUrl()) return "image-logo";
			else return "image-none";
		},
		truncate (str, len) {
			if (str && str.length > len) {
				return str.substring(0, len) + '...';
			}
			else {
				return str;
			}
		},
		showDescriptionByLanguage () {
			const descriptions = this.poi.descriptions.translations
			return descriptions[this.language.toLowerCase()]
		},
		showOpenByLanguage () {
			const openTranslations = this.poi.open.translations
			return openTranslations[this.language.toLowerCase()]
		}
	},
	data: function () {
		return {
			show_path: 'Show Path',
			show_accessibility_path: "Show Accessibility Path"
		}
	}
};
</script>

<style scoped>
	.layout-view {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}
	
	.poi-info {
		padding: 1rem;
		
	}

	.poi-info h2 {
		text-align: center;
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
	}

	.poi-body {
		box-shadow: 0px -2px 1px 0 rgba(0, 0, 0, 0.05);
		padding: 1rem;
		flex-grow: 1;
	}

	.poi-image {
		height: 14rem;
		width: 100%;
		background-position: 50% 50%;
		background-size: contain;
		background-repeat: no-repeat;
	}

	.poi-image.image-background {
		background-size: cover;
	}

	.wf-path-buttons {
		display: flex;
		gap: 1rem;
	}
	
	.show-path {
		bottom: 1rem;
		right: 1rem;
		text-transform: uppercase;
		z-index: 10;
		line-height: 2.8rem;
		margin-bottom: 1.5rem;		
	}

	.show-path button {
		height: 3rem;
		font-size: 1.2rem;
		line-height: 2.8rem;
		padding-left: 2.5rem;
		padding-right: 2.5rem;
		margin: auto;
		border: 0;
		display: block;
	}

	
	.wf-poi-description {
		line-height: 1.2;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.wf-poi-description p {
		font-size: 0.8rem;
	}
	.email-label, .description-label, .phone-label, .web-label, .open-label {
		font-size: 1.4rem;
	}

	.poi-contact .address {
		font-weight: 600;
		margin-bottom: 0.5rem;
	}

	.poi-contact .address span {
		padding-top: 4px;
		vertical-align: top;
		display: inline-block;
	}

	.poi-contact .address a {
		text-decoration: none;
		display: block;
		line-height: 1.5;
	}

	.poi-contact .address .icon:before {
		mix-blend-mode: initial;
		color: white;
	}

</style>
